import { Injectable } from "@angular/core";

import { User } from "../_models/index";
import * as moment from "moment-timezone";
import { Moment } from "moment-timezone";
import { KeycloakAuthService } from "./keycloak-auth.service";

@Injectable()
export class UserService {
    constructor(private keycloakAuthService: KeycloakAuthService) {
    }

    verify() {
        if (this.keycloakAuthService.isEnabled()) {
            return this.keycloakAuthService.isAuthenticated();
        }

        let currentUser = this.keycloakAuthService.getCurrentUser();
        if (currentUser) {
            return moment(currentUser.expires).isAfter(moment());
        }
        else {
            return false;
        }
    }

}
